import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { FetchPermissionsTemplate, FetchUserPermissionsForCurrentInvestor } from 'api/permission';
import { SET_PERMISSION_TEMPLATE, SET_USER_ACCESS } from 'store/actions';
import { adminPermission, hasPermissionForRoute, isSelectedInvestorGroup } from 'utils/index';

const PermissionsHandler = ({ investor_id }) => {
    const investor_types = useSelector((state) => state?.investorDetails?.investor_types);
    const dispatch = useDispatch();
    const [tempPermissionData, setTempPermission] = React.useState(null);
    const location = useLocation();
    const navigate = useNavigate();
    const currentInvestorType = useSelector((state) => state.investorDetails.data)?.investor_type;
    const userPermissions = useSelector((state) => state?.permissions?.userPermissions);

    const {
        data: permissions_template,
        isLoading: isLoadingPermissionsTemplate,
        refetch: refetchPermissionsTemplate
    } = FetchPermissionsTemplate();

    const {
        data: user_access_info,
        isLoading: isLoadingUserAccessInfo,
        refetch: refetchUserAccessInfo
    } = FetchUserPermissionsForCurrentInvestor({ investor_id });

    // console.log(user_access_info,"user_access_info")

    // Effect to set permissions template and user access info
    useEffect(() => {
        if (!isLoadingPermissionsTemplate && permissions_template) {


            // console.log(permissions_template, "permissions_template_invesstor")
            dispatch({ type: SET_PERMISSION_TEMPLATE, data: permissions_template });

            // console.log(user_access_info.permissions?.find(item => item),"user_access_info.permissions?.find(item => item)")

            if (!isLoadingUserAccessInfo && user_access_info) {
                if (investor_types && investor_types?.length > 0) {
                    const permissionsData = {
                        super_admin: {
                            ...user_access_info.permissions?.find(item => item)
                        }
                    };

                    // if (currentInvestorType && isSelectedInvestorGroup({ type: currentInvestorType, investor_types })) {
                    //     delete permissionsData?.startups;
                    //     // console.log(permissionsData, "permissionsData 1")
                    // } else if (currentInvestorType && !isSelectedInvestorGroup({ type: currentInvestorType, investor_types })) {
                    //     delete permissionsData?.startups_new;
                    //     // console.log(permissionsData, "permissionsData 2")
                    // }
                    // console.log(user_access_info, "permissionsData 3")
                    dispatch({
                        type: SET_USER_ACCESS, permissions: permissionsData, isOwner: user_access_info?.is_owner,
                        userName: user_access_info?.first_name + " " + user_access_info?.last_name
                    });
                }
            }
        }
    }, [permissions_template, user_access_info, isLoadingPermissionsTemplate, isLoadingUserAccessInfo, currentInvestorType, investor_types]);

    // Effect to check and validate route permissions
    // useEffect(() => {
    //     if (investor_id && userPermissions) {
    //         // refetchUserAccessInfo().then((response) => {
    //         // console.log(userPermissions, "hasPermissionForRoute", hasPermissionForRoute(userPermissions, location.pathname), "path", location.pathname)
    //         if (!hasPermissionForRoute(userPermissions, location.pathname)) {
    //             navigate('/backrr_startups', { replace: true });
    //         }
    //         // });
    //     }
    // }, [investor_id, userPermissions, navigate]);

    React.useEffect(() => {
        if (investor_id && userPermissions) {
            // if (location.pathname?.startsWith("backrr_startups") && userPermissions && JSON.parse(userPermissions)?.backrr_startups) {
            //     return true;
            // }
            // else if (location.pathname?.startsWith("backrr_investors") && userPermissions && JSON.parse(userPermissions)?.backrr_investors) {
            //     return true;
            // }
            // else if (location.pathname?.startsWith("admin_settings") && userPermissions && (JSON.parse(userPermissions)?.backrr_admin_settings_release_notes || JSON.parse(userPermissions)?.backrr_admin_settings_admin_users)) {
            //     return true;
            // }
            // else if (location.pathname?.startsWith("admin_settings/release_notes") && userPermissions && JSON.parse(userPermissions)?.backrr_admin_settings_release_notes) {
            //     return true;
            // }
            // else if (location.pathname?.startsWith("admin_settings/admin_users") && userPermissions && JSON.parse(userPermissions)?.backrr_admin_settings_admin_users) {
            //     return true;
            // }
            // else {
            //     // console.log(userPermissions, "hasPermissionForRoute", hasPermissionForRoute(userPermissions, location.pathname), "path", location.pathname)
            //     navigate('/', { replace: true });
            // }
            // if(hasPermissionForRoute(userPermissions, location.pathname)) {
            //     // console.log(userPermissions, "hasPermissionForRoute", hasPermissionForRoute(userPermissions, location.pathname), "path", location.pathname)
            //     navigate(location.pathname, { replace: true });
            // }
            // if (!hasPermissionForRoute(userPermissions, location.pathname)) {
            //     navigate('/backrr_startups', { replace: true });
            // }
        }
    }, [userPermissions, location.pathname, navigate]);

    return null; // Render nothing; this component just handles logic
};

export default PermissionsHandler;
